/* eslint-disable import/no-extraneous-dependencies */
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { AppContextProvider } from 'context';
import { ToastProvider } from 'context/ToastProvider';
import { SearchTruckerProvider } from 'context/TruckerProvider';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ContentWrapper } from './components/ContentWrapper';

const queryClient = new QueryClient();

export const OpenSearch = () => (
  <AppContextProvider>
    <QueryClientProvider client={queryClient}>
      <SearchTruckerProvider>
        <ThemeProvider theme={dsTokens}>
          <ToastProvider>
            <ContentWrapper />
          </ToastProvider>
        </ThemeProvider>
      </SearchTruckerProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </AppContextProvider>
);

export default OpenSearch;
